import { render, staticRenderFns } from "./FormElementGrammarName.vue?vue&type=template&id=9cb5ced8&scoped=true&"
import script from "./FormElementGrammarName.vue?vue&type=script&lang=js&"
export * from "./FormElementGrammarName.vue?vue&type=script&lang=js&"
import style0 from "./FormElementGrammarName.vue?vue&type=style&index=0&id=9cb5ced8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb5ced8",
  null
  
)

export default component.exports